export const dataAttrGUI = 'data-gui';
export const dataAttrTestId = 'data-testid';
export const dataAttrTracking = 'data-tracking';
